import { render } from "./fileFill.vue?vue&type=template&id=70c97b6b&scoped=true"
import script from "./fileFill.vue?vue&type=script&lang=js"
export * from "./fileFill.vue?vue&type=script&lang=js"

import "./fileFill.vue?vue&type=style&index=0&id=70c97b6b&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c97b6b"]])

export default __exports__